import SignInZendeskContainer from "../containers/SignInZendeskContainer";

const ZendeskAuthPage = () => {
  return <SignInZendeskContainer />;
};

export default ZendeskAuthPage;
